import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { baseClient } from 'builder/modules/apiClient'
import { CompanyInterview } from 'builder/modules/interview/types'
import { InitialRequest } from '../view/DashboardView/DashboardView'
import { usePerformanceOnce } from './usePerformanceOnce'

export const useCompanyInterviews = (
  jobTitleId: number | null,
  userId?: number,
  setInitialRequest?: React.Dispatch<React.SetStateAction<InitialRequest | undefined>>,
  enabledPerformanceMetric = false,
) => {
  const { registerOncePerformance, stopRegisterPerformance } = usePerformanceOnce({
    enabled: enabledPerformanceMetric,
    metricKey: `company-interviews-request`,
    tags: { jobTitleId },
    successCallBack: () => {
      if (setInitialRequest) {
        setInitialRequest(prevState =>
          prevState === undefined ? undefined : { ...prevState, companyInterview: true },
        )
      }
    },
  })

  return useQuery(
    ['useCompanyInterviews', jobTitleId],
    async () => {
      registerOncePerformance()
      const response = await baseClient.get<CompanyInterview[]>(
        `/interview_prep/company_interviews`,
        {
          params: {
            data_api_job_title_id: jobTitleId,
            user: userId,
          },
        },
      )
      stopRegisterPerformance()
      return response.data
    },
    {
      enabled: !!jobTitleId,
    },
  )
}
